import { FIRST_TIME_LOGIN_URL, OTP_SENT, VIEW_USER_PROFILE, get_headers } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { password_visibility_mixin } from '@/utils/mixins/password_visibility_mixin.js';
import { validate_non_empty_string, validate_phone_number } from '@/utils/validations/validate_inputs';
import axios from 'axios';
import $ from 'jquery';
import OnboardingIndex from '../OnboardingIndex.vue';

export default {
  name: 'FirstTimeLogin',
  mixins: [alert_mixin ,password_visibility_mixin ],
  components: {
    OnboardingIndex
  },
  data: () => ({
    show_password: false, // Toggle for password visibility
    show_confirm_password: false,
    user_first_name: null,
    user_last_name: null,
    show_name_inputs: false,
    new_password: '',
    confirm_password: '',
    phone_number:'',
    action_running: false,
    user_id: sessionStorage.getItem('user_id') || null,
    token: null,
    headers: null,
    eye_icon: 'bi-eye-slash',
  }),

  mounted() {
    this.user_id = sessionStorage.getItem('user_id');
    this.token = sessionStorage.getItem('token');
    this.headers = get_headers();
    this.get_user_details();

    if (this.user_first_name === null || this.user_last_name === null) {
      this.show_name_inputs = true;
    }

    this.document_ready();
  },
  methods: {
    async handle_success_password_change(user_id) {
      const data = { user_id };
      try {
        await axios.post(OTP_SENT, data, {
          headers: this.headers
        });
        return;
      } catch (error) {
        this.show_error('Could not send OTP to user.');
        return;
      }
    },
    async get_user_details() {
      var data = {
        user_id: this.user_id
      };
      try {
        const response = await axios.post(VIEW_USER_PROFILE, data, {
          headers: this.headers
        });
        var response_data = JSON.parse(response.data);
        this.user_first_name = response_data.data[0].user.first_name ? response_data.data[0].user.first_name : null;
        this.user_last_name = response_data.data[0].user.last_name ? response_data.data[0].user.last_name : null;
      } catch (error) {
        this.show_error('Could not get user profile.');
      }},
    async first_time_login() {
      if (!this.validate_inputs()) return;

      try {
        validate_non_empty_string(this.user_first_name, 'Your First name is required');
        validate_non_empty_string(this.user_last_name, 'Your Last name is required');
        validate_non_empty_string(this.phone_number, 'A Phone number is required');
        validate_non_empty_string(this.new_password, 'A Password is required');
        validate_non_empty_string(this.confirm_password, 'Please confirm your password');
        var data = {
          first_name: this.user_first_name,
          last_name: this.user_last_name,
          new_password: this.new_password,
          confirm_password: this.confirm_password,
          phone_number: this.phone_number,
          user_id: this.user_id
        };

        var response = await axios.post(FIRST_TIME_LOGIN_URL, data, {
          headers: this.headers
        });

        var response_data = JSON.parse(response.data);

        if (response_data.status === 'success') {
          this.show_success(response_data.message);
          this.action_running = false;

          this.handle_success_password_change(this.user_id);
          const profile_role_form_id = response_data.profile_role_form_id;
          sessionStorage.setItem('profile_role_form_id', profile_role_form_id);
          this.$router.push({
            path: '/one_time_pin',
            query: { user_id: this.user_id }
          });

        } else {
          this.show_error('Error during the form submission.');
          this.action_running = false;
        }
      } catch (error) {
        this.handle_axios_error(error);
        this.action_running = false;
      }
    },
    handle_axios_error(error) {
      let error_response_data;
      try {
        error_response_data = JSON.parse(error.response.data.replace("ERROR ", ""));
      } catch (parseError) {
        this.show_error('An unexpected error occurred. Please try again.');
        return;
      }
      if (error_response_data?.status) {
        // Clean the data
        const cleaned_data_string = error_response_data.data.replace(/^\['/, '["').replace(/'\]$/, '"]').replace(/', '/g, '", "');
        let error_messages_array;
        try {
          error_messages_array = JSON.parse(cleaned_data_string);
        } catch (parseError) {
          error_messages_array = ['This phone number is already registered in the system. Please use a different number'];
        }
        const error_messages = error_messages_array.join(' ');
        this.show_error(error_messages || 'An error occurred. Please try again.');
      } else {
        this.show_error('An unexpected error occurred. Please try again.');
      }
    },
    validate_inputs() {

      if (!this.new_password) {
          this.show_info('Password is required');
          this.action_running = false;
          return false;
      }

      if (!this.confirm_password) {
          this.show_info('Confirm password is required');
          this.action_running = false;
          return false;
      }

      if (this.new_password !== this.confirm_password) {
          this.show_info('Passwords do not match.');
          this.action_running = false;
          return false;
      }

      this.action_running = true;
      return true;
    },
    document_ready() {
      $('#show-password').on('change', function () {
        var password_field = $('.password');
        var password_field_type = password_field.attr('type');
        password_field.attr('type', password_field_type === 'password' ? 'text' : 'password');
      });
    },

    validate_phone_number(phone_number) {
      return validate_phone_number(phone_number)
    },
  }
};
